module.exports = __webpack_public_path__ + "img/rfx-logo-full.30ef78be.svg";